
<!-- 
  404 page
-->

<template lang="html">
  <div class="main-container">


    <header class="fullscreen-element no-pad centered-text" id="header-404">

        <div class="container">
          <div class="row">
            <div class="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 text-center">
              <h1>404</h1>
              <p class="lead">
                Page not found.<br/><br/>
                <router-link class="router-link-container" to="/"><link-button :label="'HOME'" ></link-button></router-link>
              </p>
            </div>
          </div>
    
        </div>
      </section>
    </header>

    <section>
      <contact-section></contact-section>
    </section>

    <section class="section-joined-bottom">
      <text-ticker page="home"></text-ticker>
    </section>

    <section class="section-joined-top">
      <footer-image></footer-image>
    </section>
  </div>
</template>


<style type="text/css">
 
  /*.article-header {
    position: relative;
    margin-top: 73px;
    height: 400px;
    overflow: hidden;
    background-size: cover;
    background-position: top;
  }*/
  #header-404 {
        display: flex;
    align-items: center;
  }

  @media only screen and (max-width: 726px) {
 /*   .article-header {
      margin-top: 50px;
      height: 250px;
      position: relative;
    }
    .article-header img {
      height:100%;
      width:auto;
      display: block;
    margin: 0 auto;
    }*/
    .article-inner {
      width: 100%;
      margin: 0 auto;
    }
  }
</style>

<script>

import LinkButton from '../components/LinkButton'
import FooterImage from '../components/FooterImage'
import ContactSection from '../components/ContactSection'
import TextTicker from '../components/TextTicker'

export default {
  name: 'fourzerofour',
  data: function () {
    return {
      mastheight: 0
    }
  },
  mounted: function () {
    this.mastheight = window.innerHeight * 0.5
    window.scrollTo(0, 0)
  },
  components: {
    LinkButton,
    FooterImage,
    ContactSection,
    TextTicker
  }
}
</script>


// WEBPACK FOOTER //
// 404.vue?4a9938fc